(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Hero: parallaxe souris + rapprochement au scroll ---------- */
  function initHero(hero) {
    var media = hero.querySelector('[data-lm2-hero-media]');
    if (!media) return;
    var intensity = parseFloat(hero.getAttribute('data-animation-intensity') || '4') / 10;

    if (reduceMotion || !hero.hasAttribute('data-lm2-parallax')) return;

    var pointerFine = window.matchMedia('(pointer: fine)').matches;
    var ticking = false;
    var mouseX = 0;
    var mouseY = 0;
    var scrollOffset = 0;

    function render() {
      var translateX = mouseX * 14 * intensity;
      var translateY = mouseY * 10 * intensity + scrollOffset;
      media.style.transform = 'scale(1.06) translate3d(' + translateX + 'px,' + translateY + 'px,0)';
      ticking = false;
    }

    if (pointerFine) {
      hero.addEventListener('mousemove', function (e) {
        var rect = hero.getBoundingClientRect();
        mouseX = (e.clientX - rect.left) / rect.width - 0.5;
        mouseY = (e.clientY - rect.top) / rect.height - 0.5;
        if (!ticking) {
          window.requestAnimationFrame(render);
          ticking = true;
        }
      });
    }

    window.addEventListener('scroll', function () {
      var rect = hero.getBoundingClientRect();
      if (rect.bottom < 0 || rect.top > window.innerHeight) return;
      scrollOffset = Math.max(0, -rect.top) * 0.06 * intensity;
      if (!ticking) {
        window.requestAnimationFrame(render);
        ticking = true;
      }
    }, { passive: true });
  }

  document.querySelectorAll('[data-lm2-hero]').forEach(initHero);

  /* ---------- Avant / après : slider tactile léger ---------- */
  function initBeforeAfter(root) {
    var handle = root.querySelector('[data-lm2-ba-handle]');
    var afterPane = root.querySelector('[data-lm2-ba-after]');
    var range = root.querySelector('[data-lm2-ba-range]');
    if (!handle || !afterPane || !range) return;

    function setPosition(percent) {
      percent = Math.min(100, Math.max(0, percent));
      afterPane.style.clipPath = 'inset(0 ' + (100 - percent) + '% 0 0)';
      handle.style.left = percent + '%';
      range.value = percent;
    }

    function positionFromClientX(clientX) {
      var rect = root.getBoundingClientRect();
      var percent = ((clientX - rect.left) / rect.width) * 100;
      setPosition(percent);
    }

    var dragging = false;
    handle.addEventListener('pointerdown', function (e) {
      dragging = true;
      handle.setPointerCapture(e.pointerId);
    });
    handle.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      positionFromClientX(e.clientX);
    });
    handle.addEventListener('pointerup', function () { dragging = false; });
    root.addEventListener('pointerdown', function (e) {
      if (e.target === handle) return;
      positionFromClientX(e.clientX);
    });

    range.addEventListener('input', function () {
      setPosition(parseFloat(range.value));
    });

    setPosition(parseFloat(range.value || '50'));
  }

  document.querySelectorAll('[data-lm2-before-after]').forEach(initBeforeAfter);

  /* ---------- Récit des collections : mise en avant du panneau visible ---------- */
  function initCollectionStory(root) {
    var panels = root.querySelectorAll('[data-lm2-story-panel]');
    if (!panels.length || !('IntersectionObserver' in window)) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          entry.target.classList.toggle('is-active', entry.isIntersecting);
        });
      },
      { root: root, threshold: 0.6 }
    );

    panels.forEach(function (panel) { observer.observe(panel); });
  }

  document.querySelectorAll('[data-lm2-collection-story]').forEach(initCollectionStory);
})();
